import React, { PureComponent } from "react";
import SearchInput from './SearchInput'
import CategoriesResults from "./CategoriesResults.js"
import RDVResults from "./RDVResults.js"
import BrandResults from "./BrandResults.js"
import PhoneResults from "./PhoneResults";
import PhoneData from "./PhoneData.js";
import RecapPage from "./RecapPage.js";
import FinalPage from './FinalPage.js'
import APIUtilities from './APIUtilities.js'
import Footer from './Footer.js';
import Header from './Header.js';
import Stepper from './Stepper.js';
import uuid from 'react-uuid';
import { track, setSessionGuid } from './posthog';

import { withRouter } from "react-router-dom";
import {
  BrowserRouter as Router,
  Route,
  Link,
  useParams,
  useHistory
} from "react-router-dom";

import "./App.css";

// Debounce : ne déclenche la recherche qu'après 500ms sans frappe.
// Évite une requête par caractère (et la race où la réponse large "s"
// écrase la réponse ciblée "s24").
function debounce(func, delay) {
  let timeout;
  return function(...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), delay);
  };
}

const steps = [
    { title: 'Catégorie', description: 'Catégorie' },
    { title: 'Marque', description: 'Marque' },
    { title: 'Modèle', description: 'Modèle' },
    { title: 'Réparations', description: 'Réparations' },
    { title: 'Récapitulatif', description: 'Récapitulatif' },
    { title: 'Tarifs', description: 'Tarifs' },
  ];

const CATEGORY_CHOICE = 1;
const BRAND_CHOICE = 2;
const MODEL_CHOICE = 3;
const PHONE_DATA = 4;
const RECAP = 5;
const RDV_PAGE = 11 ;
const FINAL_PAGE = 10;


const TABLET = 1;
const TEL = 2
const PC = 3;
const OBJECT = 4;

const NONE = -1;

class App extends PureComponent {

  constructor(props) {
    super(props);
    //CATEGORY_CHOICE
    this.state = {
      currentState:CATEGORY_CHOICE,
      currentModel: {"IDModele" : NONE},
      currentSearch: NONE+"",
      GUID: uuid(),
      showPrices: false,
      campaign : "",
      activeStep : 0,
      IDSite : undefined,
      reparationDirecte : undefined,
      rdvError : false,
      // Offre batterie (TICK00276) : chargée du back au montage, inactive par défaut.
      offreBatterie : { active: false, pourcentage: 50 },
      discountBatterie : 0
    };

    // Recherche débouncée : setState('currentSearch') seulement après 500ms d'inactivité.
    this.debouncedSetSearch = debounce((val) => this.setState({ currentSearch: val }), 500);

    this.handleClickOnCategory = this.handleClickOnCategory.bind(this);
    this.handleClickOnBrand = this.handleClickOnBrand.bind(this);
    this.handleClickOnPhone = this.handleClickOnPhone.bind(this);
    this.handleClickOnValidateItems = this.handleClickOnValidateItems.bind(this);
    this.handleClickOnSubmitDevis = this.handleClickOnSubmitDevis.bind(this);
    this.clickReturnButton = this.clickReturnButton.bind(this);
    this.handleClickOnSubmitRDVPage = this.handleClickOnSubmitRDVPage.bind(this);

    
  };

  componentDidMount() {
    const { match, history } = this.props;

    // Lecture des paramètres d'URL (même approche que getCampaignId).
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');

    const campaign = APIUtilities.getCampaignId();
    this.setState({ campaign: campaign });

    // Offre batterie (TICK00276) : config chargée en tâche de fond, fail-safe inactive.
    APIUtilities.getParametrageOffres().then((offreBatterie) => {
      this.setState({ offreBatterie: offreBatterie });
    });

    // Ouverture directe sur l'étape « prise de rendez-vous » depuis un lien court reçu par SMS
    // (URL type /rendez-vous?code=1234567). La seule présence de `code` déclenche ce mode.
    // Dans ce cas, NE PAS exécuter le history.push ci-dessous : il écraserait l'URL et ferait
    // perdre le paramètre `code`.
    if (code) {
      this.loadDevisRDV(code);
      return;
    }

    history.push("/?campagne=" + campaign);

    setSessionGuid(this.state.GUID);
    track('devis_module_ouvert', { campaign: campaign });
  }

  // Charge un devis existant et positionne directement le wizard sur la page de rendez-vous.
  loadDevisRDV = async (code) => {
    try {
      const data = await APIUtilities.getDevisRDV(code);

      if (data && data.success) {
        // Le vrai GUID reçu doit servir aux appels de créneaux (getTimeSlots lit APIUtilities.GUID)
        // et à la réservation (sendDemandeRDVDevisV2 utilise App.state.GUID).
        APIUtilities.GUID = data.GUID_Client;

        // Ce chemin court-circuite le tracking de componentDidMount : on le refait
        // ici, avec le GUID réel du devis rappelé par le lien court.
        setSessionGuid(data.GUID_Client);
        track('devis_rdv_ouvert_via_lien', { campaign: this.state.campaign });

        this.setState({
          GUID: data.GUID_Client,
          IDSite: data.IDSite,
          IsStockPieceDispo: data.IsStockPieceDispo,
          reparationDirecte: data.reparation,
          currentState: RDV_PAGE,
          activeStep: RDV_PAGE - 1
        });
      } else {
        this.setState({ rdvError: true });
      }
    } catch (error) {
      console.log(error);
      this.setState({ rdvError: true });
    }
  };

  handleClickOnCategory(category) {
    var nextState = BRAND_CHOICE;

    window.scrollTo({
            top: 0,
            behavior: "smooth",
        });

    const id = parseInt(category.IDCategorie);

    track('devis_categorie_choisie', { categorie_id: id, categorie_nom: category.LibelleCategorie, campaign: this.state.campaign });

    this.setState({
      currentCategory: category,
      currentBrand: {"id" : NONE},
      currentModel: {"IDModele" : NONE},
      selectedItems: [],
      discount: 0,
      total: 0,
      currentState: nextState,
      activeStep: nextState -1
    });
  };

  handleClickOnBrand(id, name) {
    var nextState = MODEL_CHOICE;
    var activeStepValue = nextState -1;


    if(id === 0) /* Clique sur marque "Autre" */
      nextState = RECAP;
      activeStepValue = nextState -1;

      track('devis_marque_choisie', { marque_id: id, marque: name, est_autre: id === 0, campaign: this.state.campaign });

      // Marque « Autre » : on saute l'étape prestations et on arrive directement
      // au récapitulatif. Sans cet appel, ces parcours étaient absents de
      // l'entonnoir (devis_recap_atteint n'était émis que depuis
      // handleClickOnValidateItems).
      if(nextState === RECAP)
        track('devis_recap_atteint', { nb_prestations: 0, total: 0, est_autre: true, campaign: this.state.campaign });

      this.setState({
        currentState: nextState,
        currentBrand: {"id" : id, "name" : name},
        currentModel: {"IDModele" : NONE},
        selectedItems: [],
        discount: 0,
        total: 0,
        activeStep: activeStepValue,
      }, () => window.scrollTo({
              top: 0,
              behavior: "smooth",
          }));
  };

  handleClickOnPhone(selectedPhone) {
    var nextState = PHONE_DATA;
    var activeStepValue = nextState -1;


    if(parseInt(selectedPhone.IDModele) === 0) /* Clique sur modele "Autre" */
      nextState = RECAP;
      activeStepValue = nextState -1;

    track('devis_modele_choisi', { modele_id: parseInt(selectedPhone.IDModele), modele_nom: selectedPhone.LibelleModele, est_autre: parseInt(selectedPhone.IDModele) === 0, campaign: this.state.campaign });

    // Modèle « Autre » (appareil introuvable au catalogue) : accès direct au
    // récapitulatif, même trou d'entonnoir que pour la marque « Autre ».
    if(nextState === RECAP)
      track('devis_recap_atteint', { nb_prestations: 0, total: 0, est_autre: true, campaign: this.state.campaign });

    this.setState({
      currentState: nextState,
      currentModel: selectedPhone,
      selectedItems: [],
      discount: 0,
      total: 0,
      activeStep: activeStepValue,
    }, () => window.scrollTo({
            top: 0,
            behavior: "smooth",
        }) );


  };

  clickReturnButton() {
    const currentState = this.state.currentState;
    const currentCategoryID = parseInt(this.state.currentCategory.IDCategorie);
    var nextState = currentState-1;

    if (this.state.currentState === BRAND_CHOICE) {
      window.location.reload();
    }

    window.scrollTo({
            top: 0,
            behavior: "smooth",
        });


    if(currentState === RECAP) {

      if(this.state.currentBrand.id === 0)
        nextState = BRAND_CHOICE;

      else if(parseInt(this.state.currentModel.IDModele) === 0)
        nextState = MODEL_CHOICE;
    }
    this.setState({
      currentState : nextState,
      currentSearch: NONE+"",
      activeStep: nextState -1,
    });
  };

  handleClickOnValidateItems(selectedItems, discount, total, discountBatterie) {
    if(selectedItems.length === 0) {
      alert("Veuillez selectionner au moins 1 réparation afin de continuer");
      return;
    }

    window.scrollTo({
            top: 0,
            behavior: "smooth",
        });

    APIUtilities.sendPreDevis(this.state.GUID, selectedItems, this.state.campaign);

    track('devis_recap_atteint', { nb_prestations: selectedItems.length, total: total, est_autre: false, campaign: this.state.campaign });

    this.setState({
      currentState: RECAP,
      selectedItems: selectedItems,
      discount: discount,
      total: total,
      // Remise offre batterie (TICK00276), déjà déduite du total — affichage séparé.
      discountBatterie: discountBatterie || 0,
      activeStep: this.state.currentState,
    });
  };

  handleClickOnSubmitDevis(discountCodeAmount, pe_IDSite, pe_IsStockPieceDispo) {

    window.scrollTo({
            top: 0,
            behavior: "smooth",
        });

    track('devis_soumis', {
      IDSite: pe_IDSite,
      total: this.state.total - discountCodeAmount,
      remise: this.state.discount + discountCodeAmount,
      campaign: this.state.campaign,
    });

    this.setState({
      currentState: FINAL_PAGE,
      discount: this.state.discount+discountCodeAmount,
      total: this.state.total-discountCodeAmount,
      activeStep: this.state.currentState,
      IDSite : pe_IDSite,
      IsStockPieceDispo : pe_IsStockPieceDispo
    });
  }


  handleClickOnSubmitRDVPage() {

    window.scrollTo({
            top: 0,
            behavior: "smooth",
        });

    track('devis_rdv_demande', { IDSite: this.state.IDSite, campaign: this.state.campaign });

    this.setState({
      currentState: RDV_PAGE
    });
  }







  /*Gestion du changement de text dans la barre de recherche*/
  handleSearchChange = event => {
    // React 16 : événement synthétique poolé — lire la valeur AVANT le setTimeout du debounce.
    var val = event.target.value;

    if(val === "")
      val = NONE+"";

    this.debouncedSetSearch(val);
  };

  stepper() {
    return <Stepper steps={steps} current={this.state.activeStep} />;
  }

  addReturnButton() {
    if(this.state.currentState > CATEGORY_CHOICE && this.state.currentState < FINAL_PAGE)
      return (
        <Router>
        <Link to={`/?campagne=${this.state.campaign}`}>
        <button className="return-button" onClick={this.clickReturnButton}>Retour</button>
        </Link>
        </Router>
      );
  }

  addSearchInput() {
    if(this.state.currentState === MODEL_CHOICE)
      return <SearchInput category = {this.state.currentCategory} textChange={this.handleSearchChange} brandName={this.state.currentBrand.name}/>;
  }

  getCurrentContent() {

    switch(this.state.currentState) {
    case CATEGORY_CHOICE:
      return <CategoriesResults onClickFunction={this.handleClickOnCategory}/>;

    case BRAND_CHOICE:
      return <BrandResults category = {this.state.currentCategory} onClickFunction={this.handleClickOnBrand} campaign={this.state.campaign}/>;

    case MODEL_CHOICE:
      return <PhoneResults category = {this.state.currentCategory} brandID={this.state.currentBrand.id} search={this.state.currentSearch} onClickFunction={this.handleClickOnPhone} campaign={this.state.campaign}/>;

    case PHONE_DATA:
      return <PhoneData phoneData={this.state.currentModel} onClickFunction={this.handleClickOnValidateItems} showPrices={this.state.showPrices} campaign={this.state.campaign} offreBatterie={this.state.offreBatterie}/>;

    case RECAP:
      return <RecapPage category={this.state.currentCategory} brand={this.state.currentBrand} model={this.state.currentModel}
        selectedItems={this.state.selectedItems} discount={this.state.discount} total={this.state.total} GUID={this.state.GUID}
        onClickFunction={this.handleClickOnSubmitDevis} showPrices={this.state.showPrices} IDSite={this.state.IDSite} campaign={this.state.campaign}
        offreBatterie={this.state.offreBatterie} discountBatterie={this.state.discountBatterie}/>;

    case FINAL_PAGE:
      return (<FinalPage GUID={this.state.GUID} category={this.state.currentCategory} brand={this.state.currentBrand} model={this.state.currentModel}
        selectedItems={this.state.selectedItems} discount={this.state.discount} total={this.state.total} campaign={this.state.campaign}
        IsStockPieceDispo = {this.state.IsStockPieceDispo}
        offreBatterie={this.state.offreBatterie} discountBatterie={this.state.discountBatterie}
        onClickFunction={this.handleClickOnSubmitRDVPage}
        />);

    case RDV_PAGE:
      return <RDVResults  IDSite={this.state.IDSite}  IsStockPieceDispo = {this.state.IsStockPieceDispo}  GUID={this.state.GUID} reparation={this.state.reparationDirecte} onClickFunction={this.handleClickOnCategory} campaign={this.state.campaign}/>;

    default:
      console.log("default");
      return "";
    }
  }

  render() {

    // État d'erreur simple : lien de rendez-vous invalide ou expiré (code inconnu / 404).
    if (this.state.rdvError) {
      return (
        <div className="main-content">
          <div className="page_wrapper">
            <Header />
            <div className="main-page">
              <div className="results-title">Lien invalide ou expiré</div>
            </div>
          </div>
          <Footer />
        </div>
      );
    }

    return (
      <div className="main-content">
        <div className="page_wrapper">
          <Header />
          <div className="main-page">

            {this.stepper()}
            {this.addReturnButton()}
            {this.addSearchInput()}
            {this.getCurrentContent()}
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default withRouter(App);
